import { render, staticRenderFns } from "./Arrears.vue?vue&type=template&id=2a161264&scoped=true&"
import script from "./Arrears.vue?vue&type=script&lang=js&"
export * from "./Arrears.vue?vue&type=script&lang=js&"
import style0 from "./Arrears.vue?vue&type=style&index=0&id=2a161264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a161264",
  null
  
)

export default component.exports